import { PaylinkSDK } from './paylink';
import { ApiAdapter } from './ApiAdapter';
import { CurrencySDK } from './currency';
import { TransactionSDK } from './transaction';
import { TransactionWebhookSDK } from './webhook/transaction';
import { PaylinkWebhookSDK } from './webhook/paylink';
import { SubscriptionWebhookSDK } from './webhook/subscription';
import { DepositSDK } from './deposit';
import { DepositWebhookSDK } from './webhook/deposit';
import { DepositCustomerSDK } from './deposit-customer';

export interface HelioSDKConfig {
  apiKey: string;
  secretKey: string;
  network?: 'mainnet' | 'devnet';
}

const BASE_URL_DEVNET = 'https://api.dev.hel.io/v1';
const BASE_URL_MAINNET = 'https://api.hel.io/v1';

export class HelioSDK {
  constructor(config: HelioSDKConfig) {
    const apiConfig = {
      apiKey: config.apiKey,
      secretKey: config.secretKey,
      network: config.network || 'mainnet',
    };

    const baseUrl =
      config.network === 'devnet' ? BASE_URL_DEVNET : BASE_URL_MAINNET;

    const apiAdapter = new ApiAdapter(
      baseUrl,
      apiConfig.apiKey,
      apiConfig.secretKey,
    );

    this.paylink = new PaylinkSDK(apiAdapter);
    this.deposit = new DepositSDK(apiAdapter);
    this.depositCustomer = new DepositCustomerSDK(apiAdapter);
    this.currency = new CurrencySDK(apiAdapter);
    this.transaction = new TransactionSDK(apiAdapter);
    this.transactionWebhook = new TransactionWebhookSDK(apiAdapter);
    this.subscriptionWebhook = new SubscriptionWebhookSDK(apiAdapter);
    this.paylinkWebhook = new PaylinkWebhookSDK(apiAdapter);
    this.depositWebhook = new DepositWebhookSDK(apiAdapter);
  }

  paylink: PaylinkSDK;
  deposit: DepositSDK;
  depositCustomer: DepositCustomerSDK;
  currency: CurrencySDK;
  transaction: TransactionSDK;
  transactionWebhook: TransactionWebhookSDK;
  subscriptionWebhook: SubscriptionWebhookSDK;
  paylinkWebhook: PaylinkWebhookSDK;
  depositWebhook: DepositWebhookSDK;
}
